<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="set-option-dialog"
    :mask-closable="false"
    :width="`${diaW}px`"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <template v-if="isCanDefault">
      <div
        v-if="itemData.fieldtype === 'radioinfo_type'"
        class="tip-info-tip"
      >
        {{ $t('message["1410"]') }}
        {{ $t('message["1778"]') }}
      </div>
      <div
        v-else-if="itemData.fieldtype === 'radioinfo_followup'"
        class="tip-info-tip"
        :class="{ 'tip-info-tip-english': $isEnglish}"
      >
        {{ $t('message["1411"]') }}
        {{ $t('message["1778"]') }}
      </div>
      <div
        v-else-if="itemData.fieldtype !== 'checkbox'"
        class="tip-info-tip"
      >
        {{ $t('message["1778"]') }}
      </div>
    </template>
    <div
      class="input-form set-option-form"
      :class="{'follow-type': itemData.fieldtype === 'radioinfo_followup' ||(itemData.fieldtype === 'radioinfo_type') }"
    >
      <a-form
        :form="form"
        layout="inline"
      >
        <a-form-item
          v-if=" itemData.fieldtype ==='radioinfo_type' && (Object.keys(itemData.fieldconfig).length > 0)"
          class="record-type-item"
        >
          <a-checkbox
            :default-checked="itemData.fieldconfig.isbeian === 1"
            @change="checkboxChange"
          >
            <!-- 允许标记备案 -->
            {{ $t('message[1758]') }}
            <span class="tips">{{ $t('message[1757]') }}</span>
          </a-checkbox>
        </a-form-item>
        <draggable
          v-model="itemData.options"
          @end="dragEndHandle"
        >
          <div
            v-for="(item, index) in child"
            :key="item.id || item._id"
            class="input-row"
          >
            <set-option-item
              :key="'i'+ item.id || 'i'+item._id"
              :item-data="itemData"
              :item="item"
              :is-can-default="isCanDefault"
              :index="index"
            />
          </div>
        </draggable>
        <a-form-item>
          <a-button
            class="add-option-btn"
            @click="addDefine"
          >
            <i
              class="icon iconfont iconicon-test10"
            />
            {{ $t('message["1561"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
// import Draggable from 'vuedraggable'
import SetOptionItem from './SetOptionItem'
import { mapState } from 'vuex'
export default {
  components: {
    SetOptionItem
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    cloneData: {
      type: Object,
      default () {
        return {}
      }
    },
    parentFieldkey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  provide () {
    return {
      diaform: this
    }
  },
  computed: {
    ...mapState('config/collect', ['datas']),
    child () {
      // const { child = [] } = this.itemData.options
      return this.itemData.options
    },
    diaW () {
      const { fieldtype = '' } = this.itemData
      if (this.isCanDefault) {
        if (fieldtype === 'radioinfo_followup') {
          return 712
        } else if (fieldtype === 'select' || fieldtype === 'radio') {
          return 738
        } else if (fieldtype === 'radioinfo_type') {
          return 964
        } else {
          return fieldtype !== 'checkbox' ? 615 : 490
        }
      } else {
        return fieldtype === 'select' || fieldtype === 'radio' ? 738 : 490
      }
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return this.$t('message["1037"]')
    },
    isCanDefault () {
      const { parentFieldkey } = this
      return parentFieldkey !== 'invalid_info' && parentFieldkey !== 'discard_info' && parentFieldkey !== 'deal_info'
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
    // this.form.getFieldDecorator('name', { initialValue: [], preserve: false })
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    addDefine () {
      let obj = {
        _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime(),
        issystem: 0,
        name: ''
      }

      if (this.itemData.fieldkey === 'radioinfo_type' || (this.itemData.fieldtype === 'radioinfo_followup')) {
        obj = {
          ...obj,
          issend: 0,
          isdefault: 0
        }
      } else {
        if (this.isCanDefault && this.itemData.fieldtype !== 'checkbox') {
          obj = {
            ...obj,
            isdefault: 0
          }
        } else {
        }
      }
      this.itemData.options.push(obj)
    },
    formHandle () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.itemData.options.forEach(item => {
            if (item.visibletype * 1 === 2 && Object.keys(item).includes('isdefault')) {
              this.$delete(item, 'isdefault')
            }
          })
          this.isLimitDialogShow = false
          this.$emit('getHiddenVal', this.itemData.options.join(','))
        }
      })
    },
    isEndChange (e) {
      // console.log(e)
    },
    dragEndHandle ({ oldIndex, newIndex }) {
    },
    dragUpate (dd) {
      const nameDatas = this.form.getFieldValue('name')
      nameDatas.forEach((name, index) => {
        this.itemData.options[index].name = name
      })
    },
    checkboxChange (e) {
      const val = e.target.checked ? 1 : 2
      this.$set(this.itemData.fieldconfig, 'isbeian', val)
      // item.name = this.form.getFieldValue('name')[index]
    },
    cancelHandle () {
      this.isLimitDialogShow = false
      this.$set(this.itemData, 'options', this.cloneData.options)
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-form::v-deep {
    margin: 11px 0 11px;
    padding: 0 40px;

  .record-type-item {
    margin-left: 30px;
    .tips {
      color: #b3b3b3;
      font-size: 12px;
    }
    .ant-checkbox-wrapper {
      margin-bottom: 0;
    }
  }
    .ant-input {
      width: 320px;
    }
    .add-option-btn {
      margin: 10px 32px;
      .iconicon-test10 {
        color: #ccc;
        font-size: 16px;
        margin-right: 6px;
      }
    }
  }
  .tip-info-tip {
      // position: absolute;
      height: 40px;
      line-height: 40px;
      background: #fff4e7;
      padding: 0 30px;
      color: #f6a953;
      left: 0;
      top: 47px;
      // width: 740px;

    }
     .tip-info-tip-english {
      line-height: 22px;
      height: auto;
      padding: 8px 30px
    }
    // .follow-type {
    //   margin-top: 52px;
    // }
    .set-option-form {
      max-height: 292px;
      overflow-y: auto;
    }
</style>
<style lang="scss">
.set-option-dialog {
  .ant-modal-body {
    padding: 0;
  }
}
</style>
